import { useEffect, useRef, useState } from 'react';
import { useAuthContext } from '../../auth/AuthContext';
import PageTemplate from '../../components/PageTemplate/PageTemplate';

export const PSFA_GUIDE_ORIGIN = 'https://psfa.dcat.site.preprod.grid.civilservice.gov.uk';

export default function PsfaGuideAccess({ state, path }: { state: string; path: string }) {
  const { fetchJWT } = useAuthContext();
  const form = useRef<HTMLFormElement>(null);
  const [token, setToken] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void fetchJWT({ redirectOnFail: false })
      .then(({ accessToken }) => {
        if (cancelled) return;
        if (!accessToken) setError(true);
        else setToken(accessToken);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });
    return () => {
      cancelled = true;
    };
  }, [fetchJWT]);

  useEffect(() => {
    if (token) form.current?.submit();
  }, [token]);

  return (
    <PageTemplate title="PSFA user guide">
      {error ? (
        <p role="alert">Unable to open the guide. Return to PSFA, sign in again and retry.</p>
      ) : (
        <>
          <p role="status">Opening the user guide...</p>
          <form ref={form} method="post" action={`${PSFA_GUIDE_ORIGIN}/_auth/callback`}>
            <input type="hidden" name="access_token" value={token} />
            <input type="hidden" name="state" value={state} />
            <input type="hidden" name="path" value={path} />
          </form>
        </>
      )}
    </PageTemplate>
  );
}
